import { useMemo } from "react";
import { useAppContext } from "../Context/AppContext";
import { isLoggedIn } from "../auth/authStorage";
import { useGetExplorerMessagingLimit } from "../api/queries/useGetExplorerMessagingLimit";
import { useCurrentMembership } from "./useCurrentMembership";

/** Explorer-only: max 5 messages sent per week across all conversations. */
export function useExplorerMessagingLimit() {
  const { objectId } = useAppContext();
  const userId = objectId ?? "";
  const { isExplorer } = useCurrentMembership();

  const { data: limitData, refetch: refetchLimit } = useGetExplorerMessagingLimit({
    userId,
    enabled: isLoggedIn() && !!userId && isExplorer,
  });

  const canSendMessage = useMemo(() => {
    if (!isExplorer) return true;
    return limitData?.canSendMessage !== false;
  }, [isExplorer, limitData?.canSendMessage]);

  return {
    isExplorer,
    canSendMessage,
    used: limitData?.used ?? 0,
    limit: limitData?.limit ?? 5,
    remaining: limitData?.remaining ?? 5,
    weekResetsUtc: limitData?.weekResetsUtc,
    refetchLimit,
  };
}
